import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue';
import {
  BaseDialog,
  BaseTextContent,
  XrkTableProps,
  useTableColumn,
  XrkTable,
  BaseButton,
  useCreateModal
} from 'xrk-components';
import {
  invoiceDetail,
  queryInvoicePeopleList
} from '@V/invoice/src/data-source/apis';
import { InvoiceDetailData } from '@V/invoice/src/data-source/types';
import { DetailType } from '@V/invoice/src/types';
import { formatter } from '@/utils';
import { InvoiceDetailGtPUploadDialog } from '../invoice-detail-gt-legacy';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-wtdk-p-list-dialog',
  props: {
    id: {},
    detailType: { default: 1 }
  },
  setup(__props: any) {

const props = __props;

const formData = ref<InvoiceDetailData>({
  info: {
    id: 0,
    supplierId: 0,
    supplierName: '',
    aspId: 0,
    aspName: '',
    itemName: '',
    itemId: 0,
    invoiceStatus: 0,
    openAt: '',
    invoiceAmount: 0,
    createAt: '',
    invoiceTypeName: '',
    invoiceType: 0,
    invoiceTitle: '',
    invoicePhone: '',
    invoiceIdentifierNo: '',
    invoiceOpenBank: '',
    invoiceBankNo: '',
    invoiceEnterpriseAddress: '',
    isSupplement1: 0,
    isSupplement2: 0,
    receiptFullName: '',
    receiptPhone: '',
    receiptAddress: '',
    authAt: '',
    noPassReason: '',
    invoiceBusinessType: null,
    invoiceOrderNo: '',
    dkPeopleFinishSum: 0,
    dkPeopleTotalSum: 0,
    updateAt: '',
    platformServicesPrice: 0,
    personalScalePrice: 0,
    taskAt: '',
    invoiceMethod: 0,
    taxRate: 0,
    email: '',
    receiptAddressName: '',
    orderMixtureType: null,
    professionType: 0,
    theSeller: 0,
    theSellerName: '',
    demand: ''
  },
  detailListBlue: [
    {
      detail: {
        id: null,
        invoiceApplyId: null,
        isMail: null,
        companyCode: '',
        companyName: '',
        trackingNo: '',
        importType: null,
        remark: '',
        createAt: null,
        invoiceType: null
      },
      imgList: [],
      fileList: []
    }
  ],
  detailListRed: [
    {
      detail: {
        id: null,
        invoiceApplyId: null,
        isMail: null,
        companyCode: '',
        companyName: '',
        trackingNo: '',
        importType: null,
        remark: '',
        createAt: null,
        invoiceType: null
      },
      imgList: [],
      fileList: []
    }
  ]
});

const getListAjax = async params => {
  return queryInvoicePeopleList({
    ...params,
    id: props.id,
    invoiceBusinessType: 3
  });
};

onMounted(async () => {
  const { data } = await invoiceDetail({
    id: props.id
  });
  formData.value = data;
});

const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号',
      width: '80px',
      fixed: 'left'
    }),
    useTableColumn({
      label: '项目参与人',
      prop: 'fullName',
      width: '180px'
    }),
    useTableColumn({
      label: '手机号',
      prop: 'userPhone',
      width: '180px'
    }),
    useTableColumn({
      label: '开票金额(元)',
      prop: 'invoicePrice',
      formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
    }),
    useTableColumn({
      label: '发票类别',
      prop: 'invoiceTypeName',
      width: '180px'
    }),
    useTableColumn({
      label: '发票类目',
      prop: 'itemName',
      width: '180px'
    }),
    useTableColumn({
      label: '开票状态',
      prop: 'invoiceStatus',
      formatter: ({ cellValue }) => (cellValue === 2 ? '已上传' : '未上传') // 2为已上传其他都为未上传
    }),
    useTableColumn({
      label: '开具发票',
      prop: 'incomePrice',
      render: ({ row }) => {
        return (
          <>
            {row.invoiceStatus === 2 && (
              <BaseButton
                type="text"
                click={async () => {
                  useCreateModal(InvoiceDetailGtPUploadDialog, {
                    invoiceImgList: row.invoiceImgList
                  });
                }}
              >
                查看
              </BaseButton>
            )}
          </>
        );
      }
    })
  ]
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "950px",
    class: "form-dialog form-dialog--label120",
    title: "发票详情",
    "model-value": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    showFooter: false
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(XrkTable), {
            ref: "xrkTableRef",
            getListAjax: getListAjax,
            searchConfig: { searchColumns: [], hide: true },
            tableConfig: tableConfig.value
          }, null, 8, ["tableConfig"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})